<template>
    <div class="admin-container">
        <h2>数据管理后台</h2>

        <!-- 搜索框 -->
        <div class="search-container">
            <div class="search-section">
                <label>搜索Graph:</label>
                <input v-model="graphSearchQuery" @input="searchGraphs" placeholder="输入关键词搜索Graph数据..."
                    class="search-input" />
                <button @click="clearGraphSearch" class="btn btn-secondary">清除</button>
            </div>
            <div class="search-section">
                <label>搜索Node:</label>
                <input v-model="nodeSearchQuery" @input="searchNodes" placeholder="输入关键词搜索Node数据..."
                    class="search-input" />
                <button @click="clearNodeSearch" class="btn btn-secondary">清除</button>
            </div>
        </div>

        <!-- Graph数据表格 -->
        <div class="data-section">
            <h3>Graph关系数据</h3>
            <div class="table-container">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>From Node</th>
                            <th>Graph (中间节点)</th>
                            <th>To Node</th>
                            <th>Strength</th>
                            <th>Description</th>
                            <th>User ID</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="graph in graphData" :key="graph.id">
                            <td>{{ graph.id }}</td>
                            <td>{{ graph.fromNode ? graph.fromNode.name : 'N/A' }}</td>
                            <td>{{ graph.graph ? (graph.graph.name || graph.graph.id || 'N/A') : 'N/A' }}</td>
                            <td>{{ graph.toNode ? graph.toNode.name : 'N/A' }}</td>
                            <td>{{ graph.strength }}</td>
                            <td>{{ graph.description.substring(0, 50) }}{{ graph.description.length > 50 ? '...' : '' }}
                            </td>
                            <td>{{ graph.userid }}</td>
                            <td>
                                <button @click="editGraph(graph)" class="btn btn-primary">编辑</button>
                                <button @click="deleteGraph(graph)" class="btn btn-danger">删除</button>
                            </td>
                            <!-- Graph编辑弹窗 -->
                            <div v-if="showGraphEditModal" class="modal" @click="closeGraphEditModal">
                                <div class="modal-content" @click.stop style="width: 500px;">
                                    <h3>编辑Graph</h3>
                                    <form @submit.prevent="updateGraph">
                                        <div class="form-group">
                                            <label>ID:</label>
                                            <input type="text" v-model="editingGraph.id" readonly
                                                class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label>From Node ID:</label>
                                            <input type="text" v-model="fromNodeId" class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label>To Node ID:</label>
                                            <input type="text" v-model="toNodeId" class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label>Graph Node ID:</label>
                                            <input type="text" v-model="graphNodeId" class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label>Strength:</label>
                                            <input type="number" v-model="editingGraph.strength" class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label>Description:</label>
                                            <textarea v-model="editingGraph.description"
                                                class="form-control"></textarea>
                                        </div>
                                        <div class="form-group">
                                            <label>User ID:</label>
                                            <input type="text" v-model="editingGraph.userid" class="form-control" />
                                        </div>
                                        <div class="button-group">
                                            <button type="submit" class="btn btn-primary">保存</button>
                                            <button type="button" @click="closeGraphEditModal"
                                                class="btn btn-secondary">取消</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination">
                <button @click="prevGraphPage" :disabled="graphPage <= 1" class="btn btn-secondary">上一页</button>
                <span>第 {{ graphPage }} 页，共 {{ graphTotalPages }} 页</span>
                <button @click="nextGraphPage" :disabled="graphPage >= graphTotalPages"
                    class="btn btn-secondary">下一页</button>
            </div>
        </div>

        <!-- Node数据表格 -->
        <div class="data-section">
            <h3>Node节点数据</h3>
            <div class="table-container">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>User ID</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="node in nodeData" :key="node.id">
                            <td>{{ node.id }}</td>
                            <td>{{ node.name }}</td>
                            <td>{{ node.description.substring(0, 50) }}{{ node.description.length > 50 ? '...' : '' }}
                            </td>
                            <td>{{ node.userid }}</td>
                            <td>
                                <button @click="editNode(node)" class="btn btn-primary">编辑</button>
                                <button @click="deleteNode(node)" class="btn btn-danger">删除</button>
                            </td>
                            <!-- Node编辑弹窗 -->
                            <div v-if="showNodeEditModal" class="modal" @click="closeNodeEditModal">
                                <div class="modal-content" @click.stop style="width: 500px;">
                                    <h3>编辑Node</h3>
                                    <form @submit.prevent="updateNode">
                                        <div class="form-group">
                                            <label>ID:</label>
                                            <input type="text" v-model="editingNode.id" readonly class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label>Name:</label>
                                            <input type="text" v-model="editingNode.name" class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label>Description:</label>
                                            <textarea v-model="editingNode.description" class="form-control"></textarea>
                                        </div>
                                        <div class="form-group">
                                            <label>User ID:</label>
                                            <input type="text" v-model="editingNode.userid" class="form-control" />
                                        </div>
                                        <div class="button-group">
                                            <button type="submit" class="btn btn-primary">保存</button>
                                            <button type="button" @click="closeNodeEditModal"
                                                class="btn btn-secondary">取消</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination">
                <button @click="prevNodePage" :disabled="nodePage <= 1" class="btn btn-secondary">上一页</button>
                <span>第 {{ nodePage }} 页，共 {{ nodeTotalPages }} 页</span>
                <button @click="nextNodePage" :disabled="nodePage >= nodeTotalPages"
                    class="btn btn-secondary">下一页</button>
            </div>
        </div>
    </div>
</template>

<script>
import { getGraphData, getNodeData, deleteGraph, deleteNode, searchGraphData, searchNodeData, updateGraph as updateGraphService, updateNode as updateNodeService } from '@/services/graphAdminService';
import AuthService from '@/services/authService';

export default {
    name: 'AdminView',
    data() {
        return {
            graphData: [],
            nodeData: [],
            graphPage: 1,
            nodePage: 1,
            graphPageSize: 10,
            nodePageSize: 10,
            graphTotalPages: 1,
            nodeTotalPages: 1,
            graphSearchQuery: '',
            nodeSearchQuery: '',
            originalGraphData: [],
            originalNodeData: [],
            showGraphEditModal: false,
            showNodeEditModal: false,
            editingGraph: {},
            editingNode: {},
            fromNodeId: '',
            toNodeId: '',
            graphNodeId: ''
        }
    },
    computed: {
        // 从editingGraph中提取ID值
        computedFromNodeId: {
            get() {
                return this.editingGraph.fromNode ? this.editingGraph.fromNode.id : '';
            },
            set(value) {
                if (!this.editingGraph.fromNode) {
                    this.editingGraph.fromNode = {};
                }
                this.editingGraph.fromNode.id = value;
            }
        },
        computedToNodeId: {
            get() {
                return this.editingGraph.toNode ? this.editingGraph.toNode.id : '';
            },
            set(value) {
                if (!this.editingGraph.toNode) {
                    this.editingGraph.toNode = {};
                }
                this.editingGraph.toNode.id = value;
            }
        },
        computedGraphNodeId: {
            get() {
                return this.editingGraph.graph ? this.editingGraph.graph.id : '';
            },
            set(value) {
                if (!this.editingGraph.graph) {
                    this.editingGraph.graph = {};
                }
                this.editingGraph.graph.id = value;
            }
        }
    },
    watch: {
        // 当editingGraph更新时，同步更新ID字段
        'editingGraph.fromNode.id'(newVal) {
            this.fromNodeId = newVal || '';
        },
        'editingGraph.toNode.id'(newVal) {
            this.toNodeId = newVal || '';
        },
        'editingGraph.graph.id'(newVal) {
            this.graphNodeId = newVal || '';
        },
        // 当ID字段变化时，更新editingGraph
        fromNodeId(newVal) {
            if (!this.editingGraph.fromNode) {
                this.editingGraph.fromNode = {};
            }
            this.editingGraph.fromNode.id = newVal;
        },
        toNodeId(newVal) {
            if (!this.editingGraph.toNode) {
                this.editingGraph.toNode = {};
            }
            this.editingGraph.toNode.id = newVal;
        },
        graphNodeId(newVal) {
            if (!this.editingGraph.graph) {
                this.editingGraph.graph = {};
            }
            this.editingGraph.graph.id = newVal;
        }
    },
    async mounted() {
        // 检查用户权限
        if (!this.checkUserPermission()) {
            // 如果没有权限，重定向到主页
            this.$router.push({ name: 'MainView' });
            return;
        }

        // 页面加载时获取数据
        await this.loadGraphData();
        await this.loadNodeData();

        // 保存原始数据用于搜索
        this.originalGraphData = [...this.graphData];
        this.originalNodeData = [...this.nodeData];
    },
    methods: {
        // 检查用户权限 - 使用与futureEngine一致的userType判断逻辑
        checkUserPermission() {
            const currentUser = AuthService.getCurrentUser();
            if (!currentUser) {
                console.log('用户未登录');
                return false;
            }

            // 先尝试获取userType字段，如果不存在则尝试user_type字段
            const userType = currentUser.userType !== undefined ? currentUser.userType : (currentUser.user_type !== undefined ? currentUser.user_type : null);
            const finalUserType = (userType !== null) ? userType : 10; // 默认值为10

            console.log('当前用户类型:', finalUserType);

            // 只有用户类型为1的管理员才能访问
            if (finalUserType !== 1) {
                console.log('用户权限不足，无法访问管理页面');
                return false;
            }

            return true;
        },

        async loadGraphData() {
            try {
                const response = await getGraphData({
                    page: this.graphPage,
                    pageSize: this.graphPageSize
                });

                // 检查响应状态
                if (response.data.status === 200) {
                    this.graphData = response.data.data?.data || [];
                    this.graphTotalPages = response.data.data?.pages || 1;

                    // 保存原始数据用于搜索（仅在非搜索状态时）
                    if (!this.graphSearchQuery) {
                        this.originalGraphData = [...this.graphData];
                    }
                } else {
                    console.error('加载Graph数据失败:', response.data.message);
                    this.$message?.error('加载Graph数据失败') || alert('加载Graph数据失败');
                }
            } catch (error) {
                console.error('加载Graph数据失败:', error);
                this.$message?.error('加载Graph数据失败') || alert('加载Graph数据失败');
            }
        },
        async loadNodeData() {
            try {
                const response = await getNodeData({
                    page: this.nodePage,
                    pageSize: this.nodePageSize
                });

                // 检查响应状态
                if (response.data.status === 200) {
                    this.nodeData = response.data.data?.data || [];
                    this.nodeTotalPages = response.data.data?.pages || 1;

                    // 保存原始数据用于搜索（仅在非搜索状态时）
                    if (!this.nodeSearchQuery) {
                        this.originalNodeData = [...this.nodeData];
                    }
                } else {
                    console.error('加载Node数据失败:', response.data.message);
                    this.$message?.error('加载Node数据失败') || alert('加载Node数据失败');
                }
            } catch (error) {
                console.error('加载Node数据失败:', error);
                this.$message?.error('加载Node数据失败') || alert('加载Node数据失败');
            }
        },
        async deleteGraph(graph) {
            if (confirm(`确定要删除Graph ID: ${graph.id} 吗？`)) {
                try {
                    await deleteGraph(graph.id);
                    this.$message?.success('删除成功') || alert('删除成功');
                    await this.loadGraphData(); // 重新加载数据
                } catch (error) {
                    console.error('删除Graph失败:', error);
                    this.$message?.error('删除失败') || alert('删除失败');
                }
            }
        },

        async deleteNode(node) {
            if (confirm(`确定要删除Node ID: ${node.id} 吗？`)) {
                try {
                    await deleteNode(node.id);
                    this.$message?.success('删除成功') || alert('删除成功');
                    await this.loadNodeData(); // 重新加载数据
                } catch (error) {
                    console.error('删除Node失败:', error);
                    this.$message?.error('删除失败') || alert('删除失败');
                }
            }
        },

        // 编辑Graph
        async editGraph(graph) {
            // 深拷贝graph对象以避免直接修改原数据
            this.editingGraph = JSON.parse(JSON.stringify(graph));

            // 初始化ID字段
            this.fromNodeId = this.editingGraph.fromNode ? this.editingGraph.fromNode.id : '';
            this.toNodeId = this.editingGraph.toNode ? this.editingGraph.toNode.id : '';
            this.graphNodeId = this.editingGraph.graph ? this.editingGraph.graph.id : '';

            this.showGraphEditModal = true;
        },

        // 编辑Node
        async editNode(node) {
            // 深拷贝node对象以避免直接修改原数据
            this.editingNode = JSON.parse(JSON.stringify(node));
            this.showNodeEditModal = true;
        },

        // 更新Graph
        async updateGraph() {
            try {
                // 使用服务函数更新Graph
                const response = await updateGraphService({
                    id: this.editingGraph.id,
                    fromNodeId: this.fromNodeId || null,
                    toNodeId: this.toNodeId || null,
                    graphId: this.graphNodeId || null,
                    strength: this.editingGraph.strength,
                    description: this.editingGraph.description,
                    userid: this.editingGraph.userid
                });

                if (response && response.data && response.data.status === 200) {
                    this.$message?.success('Graph更新成功') || alert('Graph更新成功');
                    this.closeGraphEditModal();
                    // 重新加载数据
                    await this.loadGraphData();
                } else {
                    const errorMsg = response.data?.message || '更新失败';
                    throw new Error(errorMsg);
                }
            } catch (error) {
                console.error('更新Graph失败:', error);
                this.$message?.error('更新Graph失败: ' + error.message) || alert('更新Graph失败: ' + error.message);
            }
        },

        // 更新Node
        async updateNode() {
            try {
                // 使用服务函数更新Node
                const response = await updateNodeService({
                    id: this.editingNode.id,
                    name: this.editingNode.name,
                    description: this.editingNode.description,
                    userid: this.editingNode.userid
                });

                if (response && response.data && response.data.status === 200) {
                    this.$message?.success('Node更新成功') || alert('Node更新成功');
                    this.closeNodeEditModal();
                    // 重新加载数据
                    await this.loadNodeData();
                } else {
                    const errorMsg = response.data?.message || '更新失败';
                    throw new Error(errorMsg);
                }
            } catch (error) {
                console.error('更新Node失败:', error);
                this.$message?.error('更新Node失败: ' + error.message) || alert('更新Node失败: ' + error.message);
            }
        },

        // 关闭Graph编辑弹窗
        closeGraphEditModal() {
            this.showGraphEditModal = false;
        },

        // 关闭Node编辑弹窗
        closeNodeEditModal() {
            this.showNodeEditModal = false;
        },
        async prevGraphPage() {
            if (this.graphPage > 1) {
                this.graphPage--;
                if (this.graphSearchQuery) {
                    // 如果在搜索状态下，执行搜索API
                    await this.searchGraphs();
                } else {
                    // 非搜索状态下，加载数据
                    await this.loadGraphData();
                }
            }
        },
        async nextGraphPage() {
            if (this.graphPage < this.graphTotalPages) {
                this.graphPage++;
                if (this.graphSearchQuery) {
                    // 如果在搜索状态下，执行搜索API
                    await this.searchGraphs();
                } else {
                    // 非搜索状态下，加载数据
                    await this.loadGraphData();
                }
            }
        },
        async prevNodePage() {
            if (this.nodePage > 1) {
                this.nodePage--;
                if (this.nodeSearchQuery) {
                    // 如果在搜索状态下，执行搜索API
                    await this.searchNodes();
                } else {
                    // 非搜索状态下，加载数据
                    await this.loadNodeData();
                }
            }
        },
        async nextNodePage() {
            if (this.nodePage < this.nodeTotalPages) {
                this.nodePage++;
                if (this.nodeSearchQuery) {
                    // 如果在搜索状态下，执行搜索API
                    await this.searchNodes();
                } else {
                    // 非搜索状态下，加载数据
                    await this.loadNodeData();
                }
            }
        },

        // 搜索Graph数据
        async searchGraphs() {
            if (!this.graphSearchQuery.trim()) {
                this.graphPage = 1; // 搜索清空时回到第一页
                // 如果搜索框为空，显示原始数据
                await this.loadGraphData();
                return;
            }

            try {
                const response = await searchGraphData({
                    page: this.graphPage,
                    pageSize: this.graphPageSize,
                    query: this.graphSearchQuery
                });

                if (response.data.status === 200) {
                    this.graphData = response.data.data?.data || [];
                    this.graphTotalPages = response.data.data?.pages || 1;
                } else {
                    console.error('搜索Graph数据失败:', response.data.message);
                    this.$message?.error('搜索Graph数据失败') || alert('搜索Graph数据失败');
                }
            } catch (error) {
                console.error('搜索Graph数据失败:', error);
                this.$message?.error('搜索Graph数据失败') || alert('搜索Graph数据失败');
            }
        },

        // 搜索Node数据
        async searchNodes() {
            if (!this.nodeSearchQuery.trim()) {
                this.nodePage = 1; // 搜索清空时回到第一页
                // 如果搜索框为空，显示原始数据
                await this.loadNodeData();
                return;
            }

            try {
                const response = await searchNodeData({
                    page: this.nodePage,
                    pageSize: this.nodePageSize,
                    query: this.nodeSearchQuery
                });

                if (response.data.status === 200) {
                    this.nodeData = response.data.data?.data || [];
                    this.nodeTotalPages = response.data.data?.pages || 1;
                } else {
                    console.error('搜索Node数据失败:', response.data.message);
                    this.$message?.error('搜索Node数据失败') || alert('搜索Node数据失败');
                }
            } catch (error) {
                console.error('搜索Node数据失败:', error);
                this.$message?.error('搜索Node数据失败') || alert('搜索Node数据失败');
            }
        },

        // 清除Graph搜索
        clearGraphSearch() {
            this.graphSearchQuery = '';
            this.graphData = this.originalGraphData;
        },

        // 清除Node搜索
        clearNodeSearch() {
            this.nodeSearchQuery = '';
            this.nodeData = this.originalNodeData;
        }
    }
}
</script>

<style scoped>
.admin-container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.data-section {
    margin-bottom: 40px;
}

.data-section h3 {
    margin-bottom: 15px;
    color: #333;
}

.table-container {
    overflow-x: auto;
    margin-bottom: 15px;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background-color: white;
}

.data-table th,
.data-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.data-table th {
    background-color: #f5f5f5;
    font-weight: bold;
    color: #333;
}

.data-table tr:hover {
    background-color: #f9f9f9;
}

.btn {
    padding: 6px 12px;
    margin: 0 3px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.btn-primary {
    background-color: #007bff;
    color: white;
}

.btn-primary:hover {
    background-color: #0056b3;
}

.btn-danger {
    background-color: #dc3545;
    color: white;
}

.btn-danger:hover {
    background-color: #c82333;
}

.btn-secondary {
    background-color: #6c757d;
    color: white;
}

.btn-secondary:hover {
    background-color: #5a6268;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 15px;
}

.pagination span {
    color: #666;
}

.search-container {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
}

.search-section {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
}

.search-section label {
    font-weight: bold;
    color: #333;
}

.search-input {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    width: 100%;
}

.search-input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* 模态框样式 */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-height: 80vh;
    overflow-y: auto;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
}

.form-group textarea {
    min-height: 80px;
    resize: vertical;
}

.button-group {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}
</style>